import { Input } from "antd";
import { TextAreaRef } from "antd/es/input/TextArea";
import * as React from "react";
import {
  ActivateCallback,
  useActivateCallback,
} from "src/types/ActivateCallback";

import { ZAttrTextArea } from "./ZAttrComponent";

type PropsAttrEditTextArea = {
  params: ZAttrTextArea;
  value?: unknown;
  onChange?(value: unknown): void;
  disabled?: boolean;
  activateCallback?: ActivateCallback;
  onBlur: () => void;
};

export const AttrEditTextArea: React.FC<PropsAttrEditTextArea> = (props) => {
  const { params, value, onChange, disabled, activateCallback, onBlur } = props;
  const iref = useActivateCallback<TextAreaRef>(
    activateCallback,
    (ref) => () => ref?.focus(),
  );
  return (
    <Input.TextArea
      title={JSON.stringify(value)}
      ref={iref}
      rows={params.rows ?? undefined}
      value={typeof value === "string" ? value : ""}
      onChange={(e) => onChange?.(e.currentTarget.value)}
      disabled={disabled}
      onBlur={onBlur}
    />
  );
};
